// @flow
import { useMemo } from 'react';
import map from 'ramda/es/map';
import prop from 'ramda/es/prop';
import pipe from 'ramda/es/pipe';
import toString from 'ramda/es/toString';

import toFixedValue from 'app/common/lib/toFixedValue';

import type { BudgetRecord } from '../useReportData';
import { ids } from './columns';


export type ActualItem = {
  title: string,
  count: Array<string>,
  cost: Array<string>,
  total: Array<string>,
}

export default function useActualItems(items: Array<BudgetRecord>): Array<ActualItem> {
  const res = useMemo(() => {
    return map(({ title, entries }: BudgetRecord) => ({
      [ids.TITLE]: title,
      [ids.COUNT]: map(pipe(prop('count'), toString), entries),
      [ids.COST]: map(pipe(prop('cost'), toFixedValue), entries),
      [ids.TOTAL]: map(pipe(prop('total'), toFixedValue), entries),
    }), items);
  }, [items]);

  return res;
}
